"use strict";
exports.__esModule = true;
var common_1 = require("../models/common");
var validateStructuredExample = function (value, activationPhrases, isAdmin) {
    if (!value || common_1.isEmptyExample(value)) {
        return '';
    }
    if (!value.marker) {
        return 'Выберите маркер';
    }
    if (!value.activationPhrase) {
        return 'Выберите активационное имя';
    }
    var hasMarkerWithRequest = Boolean(common_1.markers.find(function (m) { return m.text === value.marker && m.hasRequest; }));
    if (hasMarkerWithRequest && !value.request) {
        return 'Введите команду';
    }
    if (common_1.containsOneOf(value.request, common_1.triggers)) {
        return "\u0417\u0430\u043F\u0440\u043E\u0441 \u043D\u0435 \u0434\u043E\u043B\u0436\u0435\u043D \u0441\u043E\u0434\u0435\u0440\u0436\u0430\u0442\u044C \u0441\u043B\u043E\u0432\u0430 " + common_1.quotedTriggers;
    }
    if (!isAdmin && common_1.containsOneOf(value.request, common_1.reservedWords.inflected)) {
        return "\u0417\u0430\u043F\u0440\u043E\u0441 \u043D\u0435 \u0434\u043E\u043B\u0436\u0435\u043D \u0441\u043E\u0434\u0435\u0440\u0436\u0430\u0442\u044C \u0441\u043B\u043E\u0432\u0430 " + common_1.quotedReserved;
    }
    if (common_1.containsOneOf(value.request, activationPhrases)) {
        return "\u0417\u0430\u043F\u0440\u043E\u0441 \u043D\u0435 \u0434\u043E\u043B\u0436\u0435\u043D \u0441\u043E\u0434\u0435\u0440\u0436\u0430\u0442\u044C \u0430\u043A\u0442\u0438\u0432\u0430\u0446\u0438\u043E\u043D\u043D\u043E\u0435 \u0438\u043C\u044F";
    }
    return '';
};
exports["default"] = validateStructuredExample;
